const MIN_SPINNING_DURATION = 5
const MAX_SPINNING_DURATION = 1200
const DEFAULT_SPINNING_DURATION = 10
const DEFAULT_SPINS = 7
const SPINNER_WHEEL_LIMIT = 5000

export default {
  MIN_SPINNING_DURATION,
  MAX_SPINNING_DURATION,
  SPINNER_WHEEL_LIMIT,
  DEFAULT_SPINNING_DURATION,
  DEFAULT_SPINS,
}
